module.exports = __webpack_public_path__ + "static/converge6-e05975f2d5ef3a9d6943d44d86e70362.jpg";